import React, { useState, useEffect, useRef } from 'react';
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  Flex,
  Select,
  Tooltip,
} from '@chakra-ui/react';
import JobsView from './JobsView';
import SidePanelHeading from './SidePanelHeading';
import { fetchWithAuth } from '../utils/fetchWithAuth';

const JobsDrawer = ({ isOpen, onClose, defaultTab, currentPlanId, initialTaskId, hideProjectContext }) => {
  const [allPlans,   setAllPlans]   = useState([]);
  const [planFilter, setPlanFilter] = useState(currentPlanId ? String(currentPlanId) : 'all');
  const drawerContentRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    fetchWithAuth('/api/pulse/plans')
      .then(r => r.json())
      .then(d => setAllPlans(d.plans || []))
      .catch(() => {});
  }, [isOpen]);

  useEffect(() => {
    setPlanFilter(currentPlanId ? String(currentPlanId) : 'all');
  }, [currentPlanId]);

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="right" size="xl">
      <DrawerOverlay />
      <DrawerContent ref={drawerContentRef} overflow="hidden" position="relative">
        <Tooltip label="Close jobs" hasArrow><DrawerCloseButton aria-label="Close jobs" /></Tooltip>
        <DrawerHeader borderBottomWidth="1px" borderColor="gray.100" py={3}>
          <Flex align="center" justify="space-between" wrap="wrap" gap={2} pr={8}>
            <SidePanelHeading icon="task_alt">The tasks I'm doing for you</SidePanelHeading>
            {!hideProjectContext && allPlans.length > 1 && (
              <Select size="sm" w="auto" minW="130px" maxW="200px" value={planFilter}
                onChange={e => setPlanFilter(e.target.value)}
                borderColor="gray.200" fontSize="xs" color="gray.700" flexShrink={0}>
                <option value="all">All plans</option>
                {allPlans.map(p => (
                  <option key={p.id} value={String(p.id)}>{p.plan_name || `Plan ${p.id}`}</option>
                ))}
              </Select>
            )}
          </Flex>
        </DrawerHeader>
        <DrawerBody p={0} display="flex" flexDirection="column" overflow="hidden">
          <JobsView
            defaultTab={defaultTab}
            planFilter={planFilter}
            initialTaskId={initialTaskId}
            onCloseDrawer={onClose}
            hideProjectContext={hideProjectContext}
            detailPortalContainerRef={drawerContentRef}
          />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default JobsDrawer;
